import { render, staticRenderFns } from "./Artist.vue?vue&type=template&id=f1bb596a"
import script from "./Artist.vue?vue&type=script&lang=js"
export * from "./Artist.vue?vue&type=script&lang=js"
import style0 from "./Artist.vue?vue&type=style&index=0&id=f1bb596a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports